import React, { useState } from 'react'
import { Box, Container, useMediaQuery, IconButton, Drawer } from '@mui/material'
import { ChevronLeft } from '@mui/icons-material'
import Sidebar from '../Sidebar/Sidebar'
import InformationEditor from '../ProfileEditor/InformationEditor'
import ResumeEditor from '../ResumeEditor/ResumeEditor'
import Navbar from '../Navbar/Navbar'
import { useTheme } from '../../context/ThemeContext'
import { getTheme } from '../../theme/theme'
import { useProfiles } from '../../context/ProfileContext'

const DRAWER_WIDTH = { xs: '85%', sm: 320 }
const TOOLBAR_HEIGHT = { xs: 56, sm: 64 }

const SPAContainer = () => {
  const { activeProfile } = useProfiles()
  const [mobileOpen, setMobileOpen] = useState(false)
  const { isDarkMode } = useTheme()
  const [activeEditor, setActiveEditor] = useState('profile') // 'profile' or 'resume'
  const theme = getTheme(isDarkMode ? 'dark' : 'light')
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const handleProfileEditorSelect = () => {
    setActiveEditor('profile')
  }

  const handleResumeEditorSelect = () => {
    setActiveEditor('resume')
  }

  const sidebarContent = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {isMobile && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            minHeight: TOOLBAR_HEIGHT,
            px: 2,
          }}
        >
          <IconButton onClick={handleDrawerToggle}>
            <ChevronLeft />
          </IconButton>
        </Box>
      )}
      <Box sx={{ flex: 1, overflow: 'auto', px: 2 }}>
        <Sidebar onProfileEditorSelect={handleProfileEditorSelect} onResumeEditorSelect={handleResumeEditorSelect} />
      </Box>
    </Box>
  )

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: 'background.default',
        px: 0,
      }}
    >
      <Navbar onDrawerToggle={handleDrawerToggle} />

      {/* Mobile Drawer */}
      {isMobile && (
        <Drawer
          variant='temporary'
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              width: DRAWER_WIDTH,
              bgcolor: 'background.paper',
            },
          }}
        >
          {sidebarContent}
        </Drawer>
      )}

      {/* Desktop Sidebar */}
      {!isMobile && (
        <Box
          component='nav'
          sx={{
            width: DRAWER_WIDTH.sm,
            flexShrink: 0,
            borderRadius: 2,
            overflow: 'hidden',
            mt: `${TOOLBAR_HEIGHT.sm}px`,
            ml: 3,
            bgcolor: 'background.paper',
          }}
        >
          {sidebarContent}
        </Box>
      )}

      {/* Main Content */}
      <Box
        maxWidth='100%'
        component='main'
        sx={{
          flexGrow: 1,
          borderColor: 'red',
          minHeight: '100vh',
          pt: `${TOOLBAR_HEIGHT[isMobile ? 'xs' : 'sm']}px`,
          px: { xs: 0, sm: 0, md: 1 },
          pb: 3,
        }}
      >
        <Container
          sx={{
            height: '100%',
            borderColor: 'red',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {activeEditor === 'profile' ? <InformationEditor profile={activeProfile} /> : <ResumeEditor />}
        </Container>
      </Box>
    </Box>
  )
}

export default SPAContainer
